import { Loader, PageHeader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import { CreateTopBannerForm } from '~/features/CreateTopBannerForm';
import styles from './index.module.scss';

export const Screen: React.FC = () => {
  return (
    <>
      <PageHeader
        variant='breadcrumb'
        breadcrumbItems={[
          { label: 'コンテンツ配信' },
          { label: 'バナー', href: '/top-banners' },
          { label: '新規作成' },
        ]}
      />
      <div className={styles.content}>
        <span className={styles.content__title}>バナーの新規作成</span>
        <Suspense fallback={<Loader />}>
          <CreateTopBannerForm />
        </Suspense>
      </div>
    </>
  );
};
